<template lang="pug">
  .container.grid-xl
    page-title(title="Assinaturas" icon="fas fa-dollar-sign" subtitle="Veja quem assinou aos planos DentalGO")
      div(slot="actions")
        router-link.btn.btn-link.tooltip.tooltip-left(
            :to="{ name: 'subscriptions.list.filter', query: $route.query }"
            data-tooltip="Filtrar"
          )
            i.fas.fa-filter
            span.badge(v-if="Boolean($route.query.q)")
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      .columns(v-if="list")
        .column.col-4.col-lg-6.col-sm-12.mb-2.pb-2(v-for="subscription in list.rows")
          row(:subscription="subscription")
    router-view
</template>

<script>
import subscriptions from '@/services/subscriptions'
import Row from './components/Row'

export default {
  data() {
    return { loading: false, error: null, list: null }
  },
  components: { Row },
  watch: {
    '$route.query.q'() {
      const params = this.$route.query
      this.fetchData(params)
    },
  },
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await subscriptions.list({ ...params })
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    const params = this.$route.query
    this.fetchData(params)
  },
}
</script>
